import React, { useEffect, useState } from 'react';

import { useFormikContext } from 'formik';

function OneTimeTotal({ typeView, template }) {
  const [total, setTotal] = useState(0);
  const [totalCurrency, setTotalCurrency] = useState({});

  const {
    values: {
      onetime_discount_enable,
      onetime_discount,
      onetime_custom_records,
      activation_fee_type,
      employees_covered,
    },
    touched,
  } = useFormikContext();

  useEffect(() => {
    if (
      // typeView == "template" ||
      // touched.onetime_discount_enable ||
      // touched.onetime_discount ||
      // touched.onetime_custom_records
      true
    ) {
      let total = 0;
      const currencies = {};

      onetime_custom_records.forEach((item) => {
        if (item.price != '') {
          const price = Number(item.price) * (item.is_activation_fee
            && activation_fee_type === 'member'
            ? parseFloat(employees_covered) : 1);

          total += Number(price);
        }

        if (typeView == 'template') {
          item.currency_prices.forEach((currencyPrice) => {
            if (currencies[currencyPrice.currency] === undefined) {
              currencies[currencyPrice.currency] = 0;
            }
            const price = Number(currencyPrice.price) * (item.is_activation_fee
              && activation_fee_type === 'member'
              ? parseFloat(employees_covered) : 1);
            currencies[currencyPrice.currency] += Number(price);
          });
        }
      });
      if (onetime_discount_enable && onetime_discount != '') {
        const discount = (100 - Number(onetime_discount)) / 100;
        total *= discount;

        if (typeView == 'template') {
          for (const [currency, price] of Object.entries(currencies)) {
            currencies[currency] *= discount;
          }
        }
      }

      setTotal(total.toFixed(2));
      setTotalCurrency(currencies);
    }
  }, [
    onetime_discount_enable,
    onetime_discount,
    onetime_custom_records,
    employees_covered,
    touched.onetime_discount_enable,
    touched.onetime_discount,
    touched.onetime_custom_records,
    touched.employees_covered,
  ]);

  return (
    <>
      {typeView === 'policy' && (
      <h2>
        One-Time Premium Total:
        {' '}
        {template.currency.mark}
        {total}
        {' '}
        {template.currency.title}
      </h2>
      )}
      {typeView === 'template' && (
        <h2>
          One-Time Premium Total:
          <ul>
            {Object.entries(totalCurrency).map((item) => (
              <li>{`${item[0]}:${item[1]}`}</li>
            ))}
          </ul>
        </h2>
      )}
    </>
  );
}

export default OneTimeTotal;
